// De naam van een matrixkolom zoals hij in de cel zelf komt te staan.
//
// Waarom dit bestaat: onder de 768px stapelt een matrixvraag zich tot losse
// rijen en vervallen de kolomkoppen bovenaan. Elke cel draagt zijn kolomnaam
// dan zelf — en een kolom zonder titel zou daar een naamloos bolletje worden.
// Dat is geen bedachte randgeval: bij een bipolaire matrix (stelling links,
// tegenstelling rechts) draagt de PLEK de betekenis, dus laat de opsteller de
// kolommen leeg. Platformbreed 22 zulke kolommen over 6 vragen.
//
// De titel staat lang niet altijd als tekst in de database: 5157 van de 5797
// kolommen hebben een getal. Vandaar `String(...)` vóór het trimmen.
// AI-CONTEXT: See docs/pitfalls.md#database-string-enum-boolean-coercion

/**
 * @param {{Title?: string|number}} [column] - De kolom uit MatrixQuestionColumns
 * @param {number} colIndex - Nulgebaseerde plek van de kolom in de rij
 * @param {Object<string, string>} [translations] - Vertaalde teksten, op brontekst gesleuteld
 * @returns {string} Wat de invuller naast het keuzerondje leest
 */
const matrixColumnLabel = (column, colIndex, translations) => {
    const title = column?.Title;
    const asText = String(title ?? '').trim();

    if (asText === '') return String(colIndex + 1);

    return translations?.[asText] || asText;
};

export default matrixColumnLabel;
